<div class="auth-main" *ngIf="hasAuthCodeContext">
    <div class="auth-main__content">
        <img
            class="auth-main__mobile-logo"
            src="./assets/icons/auth/brand-logo.svg"
            alt="Логотип"
        />
        <div class="auth-main__title">
            <img src="./assets/icons/auth/back.svg" (click)="goBack()" alt="" />
            <span>{{ AuthFormTitle }}</span>
        </div>
        <div class="auth-code">
            <p class="label-text auth-code__description">
                Введите код подтверждения из
                {{ authData().delieveryChanel === 'SMS' ? 'СМС' : 'письма' }}
            </p>
            <p class="label-text auth-code__recipient">
                {{ formattedPhoneOrMail() }}
            </p>
            <app-otp-input
                [(code)]="otpCode"
                (codeChange)="onOtpChange($event)"
                (codeComplete)="onOtpComplete($event)"
            >
            </app-otp-input>
            <div class="status-message" *ngIf="loadingCheckCode()">
                <div class="css-spinner"></div>
                <span>Проверяем код...</span>
            </div>
            <!-- Сообщение об ошибке -->
            <div class="error-message" *ngIf="errorMessage()">
                {{ errorMessage() }}
            </div>
            <!-- Повторная отправка -->
            <span class="auth-code__timer" *ngIf="isTimerRunning()">
                Запросить код повторно можно через
                <strong>{{ timerDisplay() }}</strong>
            </span>

            <button
                *ngIf="!isTimerRunning()"
                type="button"
                class="auth-code__resend-button"
                (click)="resendAuthCode()"
            >
                <span *ngIf="!loadingResendCode">Запросить код повторно</span>
                <span *ngIf="loadingResendCode" class="css-spinner"></span>
            </button>
        </div>
    </div>
    <div class="auth-main__img">
        <img class="img-logo" src="./assets/icons/auth/brand-logo.svg" alt="" />
        <img
            class="img-doctor"
            src="./assets/icons/auth/recovery-illustration.svg"
            alt=""
        />
    </div>
</div>
